import { useEffect, useState } from "react";
import { formatToEuroDate, formatToStringISODate } from "../../util/DateUtils";

type returnValue = {
  messzeitpunkt: string;
  spaetmesstermin: Date | null;
}

type ThisProps = {
  messzeitpunkt: string;
  spaetmesstermin: Date | null;
  messzeitpunktChanged: (value: returnValue) => void;
}

/**
 * @author noone
 */
const MesszeitpunktComponent: React.FC<ThisProps> = (props) => {

  const [messzeitpunkt1, setMesszeitpunkt1] = useState<string>((props.messzeitpunkt && props.messzeitpunkt.split("_")[0]) || "");
  const [messzeitpunkt2, setMesszeitpunkt2] = useState<string>((props.messzeitpunkt && props.messzeitpunkt.split("_")[1]) || "");
  const [spaetmesstermin, setSpaetmesstermin] = useState<Date | null>(props.spaetmesstermin);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const dateValue = new Date(e.target.value);
    setSpaetmesstermin(dateValue);
  }

  useEffect(() => {

    if (messzeitpunkt2 !== "eilig") {
      setSpaetmesstermin(null);
    }

    props.messzeitpunktChanged({
      messzeitpunkt: messzeitpunkt1 + (messzeitpunkt2 ? "_" + messzeitpunkt2 : ""),
      spaetmesstermin: spaetmesstermin ? new Date(spaetmesstermin) : null
    });
  }, [messzeitpunkt1, messzeitpunkt2, spaetmesstermin]);

  return (
    <>
      Messzeitpunkt:

      <select value={messzeitpunkt1} className='form-control' name='messzeitpunkt1' style={{ width: "auto", display: "inline" }} onChange={(e) => { e.preventDefault(); setMesszeitpunkt1(e.target.value); setMesszeitpunkt2(""); }}>
        <option value="">-- Bitte auswählen --</option>
        <option value="1">Neubau</option>
        <option value="2">Sanierung</option>
        <option value="3">Bestand</option>
      </select>

      {messzeitpunkt1 === "1" &&
        <>
          <i className="bi bi-arrow-right"></i>
          <select value={messzeitpunkt2} className='form-control' style={{ width: "auto", display: "inline" }} name='messzeitpunkt2' onChange={(e) => { e.preventDefault(); setMesszeitpunkt2(e.target.value); }}>
            <option value="">-- Bitte auswählen --</option>
            <option value="sofort">Sofort</option>
            <option value="nachPutz">Nach Putz</option>
            <option value="nachEstrich">Nach Estrich</option>
            <option value="eilig">Eilig (Unterlagen zurück bis zum)</option>
          </select>
        </>
      }

      {messzeitpunkt1 === "2" &&
        <>
          <i className="bi bi-arrow-right"></i>
          <select value={messzeitpunkt2} className='form-control' style={{ width: "auto", display: "inline" }} name='messzeitpunkt2' onChange={(e) => { e.preventDefault(); setMesszeitpunkt2(e.target.value); }}>
            <option value="">-- Bitte auswählen --</option>
            <option value="sofort">Sofort</option>
            <option value="nachPutz">Nach Putz</option>
            <option value="nachEstrich">Nach Estrich</option>
            <option value="eilig">Eilig (Unterlagen zurück bis zum)</option>
          </select>
        </>
      }

      {messzeitpunkt1 === "3" &&
        <>
          <i className="bi bi-arrow-right"></i>
          <select value={messzeitpunkt2} className='form-control' style={{ width: "auto", display: "inline" }} name='messzeitpunkt2' onChange={(e) => { e.preventDefault(); setMesszeitpunkt2(e.target.value); }}>
            <option value="">-- Bitte auswählen --</option>
            <option value="sofort">Sofort</option>
            <option value="eilig">Eilig (Unterlagen zurück bis zum)</option>
          </select>
        </>
      }

      {messzeitpunkt2 === "eilig" &&
        <>
          <i className="bi bi-arrow-right"></i>
          <input type="date" className='form-control' style={{ width: "auto", display: "inline" }} name="spaetmesstermin" value={spaetmesstermin ? formatToStringISODate(spaetmesstermin) : ""} onChange={handleChange} />
        </>
      }

    </>
  );
}

export default MesszeitpunktComponent;